import React from 'react';
import Dialog from '../Dialog/Dialog';
import Button from '../Button/Button';
import './ConfirmationDialog.css';

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: 'primary' | 'secondary';
  isLoading?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  message,
  confirmText = 'Delete',
  cancelText = 'Cancel',
  confirmVariant = 'primary',
  isLoading = false
}) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title=""
      showCloseButton={false}
      actions={null}
      headerActions={null}
      className="confirm-delete-dialog"
    >
      <p>{message}</p>
      
      <div className="confirm-delete-actions">
        <Button 
          variant="secondary" 
          onClick={onClose}
          size="small"
          disabled={isLoading}
        >
          {cancelText}
        </Button>
        <Button 
          variant={confirmVariant}
          onClick={onConfirm}
          size="small"
          className={confirmVariant === 'primary' ? 'delete' : ''}
          disabled={isLoading}
          isLoading={isLoading}
        >
          {confirmText}
        </Button>
      </div>
    </Dialog>
  );
};

export default ConfirmationDialog; 